import { render, staticRenderFns } from "./OldLandingPage.vue?vue&type=template&id=1bad56a2&"
import script from "./OldLandingPage.vue?vue&type=script&lang=js&"
export * from "./OldLandingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports